/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import * as types from './mutation-types'

export const loadSaved = ({ commit }) => {
  const data = localStorage.getItem('accessToken')
  if (data) {
    commit(types.STORE, { email: data })
  }
}

export const store = ({ commit }, payload) => {
  commit(types.STORE, payload)
}

export const storePermissions = ({ commit }, payload) => {
  commit(types.STORE_PERMISSIONS, payload)
}

export const update = ({ commit }, payload)  => {
	commit(types.UPDATE, payload)
}

export const updatePermissions = ({ commit }, payload)  => {
	commit(types.UPDATE_PERMISSIONS, payload)
}

export default {
  store,
  storePermissions,
  update,
  updatePermissions,
  loadSaved,
}



// WEBPACK FOOTER //
// ./src/store/modules/account/actions.js